export default (theme) => ({
  tagsContainer: {
    fontWeight: "500",
    wordBreak: "break-word",
    color: theme.internalBlack,
    padding: "7px 5px 5px 5px !important",
    minHeight: "25px",
    maxHeight: "55px",
    overflow: "auto",
    whiteSpace: "pre-line",
    display: ["-webkit-flex", "-ms-flexbox", "flex"],
    flexWrap: "wrap",
    boxSizing: "content-box",
    width: "stretch",
    backgroundColor: theme.lightWhite,
    zIndex: "4",
  },
  tag: {
    height: "25px",
    lineHeight: "25px",
    padding: "0 10px !important",
    border: "0",
    borderRadius: "7px",
    backgroundColor: theme.primaryColor,
    display: "inline-block",
    color: theme.internalWhite,
    margin: "0 2px 5px 2px",
    fontSize: "0",
    whiteSpace: "nowrap",
    width: "fit-content",
  },
  tagText: {
    fontSize: "15px",
    fontWeight: "600",
    verticalAlign: "middle",
    display: "inline-block",
    position: "relative",
    top: "50%",
    transform: "translateY(-50%)",
  },
});
